import { createRouter, createWebHistory } from 'vue-router';
import routes from '@/routes/website';

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Restore browser back/forward position; otherwise always start at the top
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0 };
  },
});

export default router;
